import React, { useState, useEffect, useRef } from 'react';
import InfoCard from './InfoCard';
import GeocoderControl from './GeocoderControl';
import * as turf from '@turf/turf';
import SliderControl from './SliderControl';
import ToggleSwitch from './ToggleButton';

const ListView = ({ onClearFromParent, selectedCounty, setEventDataFromFilter, items, onItemClick, map, config, onClearClick }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [eventData, setEvents] = useState(items);
    const [eventsFiltered, setEventsFiltered] = useState([]);
    const [eventsFilteredAll, setEventsFilteredAll] = useState([]);
    const [searchRadius, setSearchRadius] = useState(100);
    const geocoderRef = useRef();
    const [isOn, setIsOn] = useState(false);

    const handleGeoSearchResult = (item) => {
        setSearchTerm(item);
    };

    const handleSliderRadiusChange = (radius) => {
        setSearchRadius(radius);
        if (searchTerm) {
            filterGeoJSONByDistance(searchTerm);
        }
    };

    const onClear = (item) => {
        setEventsFiltered(eventData);
        setSearchTerm('');
        onClearClick();
        setSearchRadius(100);
        geocoderRef.current?.clear();

        setTimeout(() => {
            const input = document.querySelector('.mapboxgl-ctrl-geocoder input');
            input?.blur();
        }, 0);
    };

    const onSearch = () => {
        if (searchTerm) {
            filterGeoJSONByDistance(searchTerm);
        }
        
    };


    useEffect(() => {
        if (onClearFromParent) {
            onClear(); 
        }
    }, [onClearFromParent]);


    const filterGeoJSONByDistance = (centerPoint) => {
        const center = turf.point(centerPoint); // [lng, lat]
        const eventsFilterd = eventData?.features?.filter((feature) => {
            const distance = turf.distance(center, feature, { units: 'kilometers' });
            return distance <= searchRadius;  //this is KM
        });


        const emptyListItem = [];
        emptyListItem.push(
            {
                properties: {
                    EventName: "No Results Found",
                    EventFormattedAddress: "Please change search criteria"
                }             
            }
        )

        const filteredList = {
            features: (eventsFilterd.length > 0) ? eventsFilterd : emptyListItem
        }

        setEventsFiltered(filteredList);

        setEventDataFromFilter(filteredList);

        setEventsFilteredAll(filteredList);

    };

    const filterGeoJSONByCounty = (countyGeometry) => {

        const filtered = turf.pointsWithinPolygon(eventData, {
            type: 'Feature',
            geometry: countyGeometry,
            properties: {}
        });

        const emptyListItem = [];
        emptyListItem.push(
            {
                properties: {
                    EventName: "No Results Found",
                    EventFormattedAddress: "Please change search criteria"
                }
            }
        )

        const filteredList = {
            features: (filtered.features.length > 0) ? filtered.features : emptyListItem
        }

        setEventsFiltered(filteredList);

        setEventDataFromFilter(filteredList);
    };

    useEffect(() => {
        if (selectedCounty) {
            filterGeoJSONByCounty(selectedCounty)
        }

    }, [selectedCounty]);

    useEffect(() => {
        setEvents(items);
        
        setEventsFilteredAll(items);

        setEventsFiltered(items);

    }, [items]);


    useEffect(() => {
        if (searchTerm) {
            filterGeoJSONByDistance(searchTerm)
        }
    }, [searchTerm]);

    return (
        <div>
            <div className="wrapper">
                <div className="scrollable-list">

                    <ul style={{ padding: 0, listStyleType: 'none' }}>
                        {eventsFiltered?.features?.map((item, index) => (
                            <InfoCard key={index} item={item} onClick={onItemClick} />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ListView;

